// extracted by mini-css-extract-plugin
export default {"whosWho":"leader-cards_whosWho__NZ54z","sectionTitle":"leader-cards_sectionTitle__lw0dC","leaderList":"leader-cards_leaderList__se+BH","leaderCard":"leader-cards_leaderCard__m-SL3"};